import { PasswordLogin } from "./PasswordLogin";

export { PasswordLogin };
